<template>
  <div>
    <b-card
      style="width: 1000px; margin-left: 230px; margin-top: 50px"
      header="OSD MESSAGE"
    >
      <b-row style="margin-left: 250px">
        <div class="col-md-8">
          <div class="form-group mt-8 mt-sm-0">
            <label for="default">CAN</label>
            <input
              v-model="can"
              class="form-control"
              type="text"
              placeholder="Enter CAN"
            />
          </div>
          <div class="form-group mt-8 mt-sm-0">
            <!-- <label for="default">MESSAGE</label>
            <input
              v-model="message"
              class="form-control"
              type="text"
              placeholder="Enter MESSAGE"
            /> -->
            <v-select
              v-model="message"
              :items="messages"
              label="Messages"
              item-text="message"
              item-value="templateId"
              ><template slot="selection" slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :key="JSON.stringify(data.item)"
                  class="chip--select-multi"
                  @input="data.parent.selectItem(data.item)"
                >
                  <v-avatar>
                    <img :src="data.item.avatar" />
                  </v-avatar>
                  {{ data.item.templateId }} - {{ data.item.message }}
                </v-chip>
              </template>
            </v-select>
            <input type="file" ref="uploadImage" @change="onImageUpload()" />
            <!-- 
            
  <v-file-input
  
    label="File input"
    ref="uploadImage"
@change="onImageUpload()"
  ></v-file-input> -->
            <!-- <input type=”file” ref=”uploadImage”
@change="onImageUpload()"> -->
          </div>
          <v-btn class="primary mr-4" @click="handleSubmit">Submit</v-btn>
          <!-- <b-button  class="primary mr-4" @click="handleSubmit">Get Details</b-button> -->
        </div>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import { extractError } from "../../utils/error";
import axios from "axios";
// import { Osdmessage } from "@/services/wallet";
import { Osdmessage } from "@/services/walletupdate";
import { fetchmessages } from "@/services/serviceRequest";
export default {
  data() {
    return {
      formData: null,
      radios: "credit",
      form: {
        accountNo: "",
        amount: "",
      },
      mnumber: "",
      mobilenumberRules: [(v) => !!v || "Mobile Number is required"],
      valid: true,
      select: null,
      id: "",
      serialno: "",
      id1: "",
      show: false,
      name: "",
      loading: true,
      can: "",
      message: "",
      messages: [],
    };
  },
  mounted() {
    this.demo();
  },

  methods: {
    // selectFile() {
    //   this.selectedFiles = this.$refs.file.files;
    // },
    onImageUpload() {
      // debugger
      let file = this.$refs.uploadImage.files[0];
      this.formData = new FormData();
      this.formData.append("file", file);
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    async demo() {
      const result = await fetchmessages();
      this.messages = result.response.response;
      console.log("hai", this.messages);
    },
    async handleSubmit() {
      if (this.formData != null) {
        const request = axios
          .post("https://test.bripl.in/v1/api/osd/bulk", this.formData, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then(function (response) {
            this.$toasted.success("successfully uploaded", upload_file);
          });
        // axios.POST({url:`http:your.rest.ap`,data:this.formData,
        // headers:{Accpet: "application/json",content-type:"multipart/form-data"}, })
      } else {
        try {
          const result = await Osdmessage({
            can: this.can,
            templateId: "" + this.message,
          });
          if (result)
            this.$toasted.success("Successfully created", {
              duration: 2000,
            });
          this.can = "";
          this.message = "";
        } catch (err) {
          const message = extractError(err);
          this.$showError(message);
        }
      }
    },
    async refresh() {
      setTimeout(function () {
        location.reload();
      }, 200);
    },
  },
};
</script>
<style scoped>
/* .forum{
    margin-left:3 rem !important;
} */
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  background: linear-gradient(225deg, #59065d 0%, #8d0b93 50%, #061d48 100%);
  color: white;
}
</style>
